import { NameResourceItem } from "../NameResourceItem";
import { createFullClassResource } from "../../fullResource";

export class IngredientGroup extends NameResourceItem {}

export const ingredientGroupResource = createFullClassResource(
  "plm/ingredientGroup/",
  IngredientGroup,
);
